import { useState, useEffect } from 'react'
import '../src/styles/globals.css'
import '../src/styles/tailwind.min.css';
import '../src/styles/generalStyle.css'
import '../src/styles/antd.css'
import Header from '../src/components/header_'
import Footer from '../src/components/footer'
import { Provider } from 'react-redux';
import configureStore from '../src/redux/configureStore';
import { ThemeProvider, jssPreset } from "@material-ui/core/styles"
import CustomTheme from '../public/assets/custom_theme'
import { create } from "jss"
import rtl from "jss-rtl"
import CustomizedSnackbars from '../src/modules/customized_snackbars'
import CustomDrawer from '../src/components/custom_drawer'
import CssBaseline from '@material-ui/core/CssBaseline'
import Api from '../pages/api/api'
import { StylesProvider } from '@material-ui/core'

const store = configureStore()
function MyApp({ Component, pageProps, err }) {

  const jss = create({ plugins: [...jssPreset().plugins, rtl()] })
  const [isGuest, setIsGuest] = useState(false)

  useEffect(() => {
    getuserStatus()
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles);
    }
  }, []);

  async function getuserStatus() {
    Api.checkToken().then(result => {
      if (result !== undefined) {
        setIsGuest(true)
      }
    })
  }

  return (
    <Provider store={store}>
      <ThemeProvider theme={CustomTheme}>
        <StylesProvider jss={jss}>
         {/*  <Container> */}
            <Header isGuest={isGuest} />
            <CssBaseline />
            <Component {...pageProps} err={err} />
         {/*  </Container> */}
          <Footer />
          {/*      <CustomModal /> */}
            <CustomDrawer />
            <CustomizedSnackbars />
        </StylesProvider>
      </ThemeProvider>
    </Provider>
  )
}

export default MyApp
